const StackPlayerInterface = {
    getId() {
        return this.id;
    },
    getPoints() {
        return this.points;
    },
    getMaxExposure() {
        return this.exposure.max;
    },
    getIsKeyPlayerTeam() {
        return this.isKeyPlayerTeam;
    },
    getStackablePlayerPositionNames() {
        return this.stackablePlayerPositionNames;
    },
};

export default StackPlayerInterface;
